/**
 *  Main
 *
 *  Created by Legman on 19/9/2015.
 *
 */

import Application      from "./Application";
import PreloaderScene   from "./../scenes/GenericPreloaderScene";
import Common           from "./Common";
import Bump             from "./Bump";
import isMobile         from "ismobilejs";

/**
 * @class
 */
export default class Main {
    /**
     * @param {number} width
     * @param {number} height
     */
    constructor(width, height) {
        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {GenericPreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;
    }

    init() {

        const bump = new Bump(PIXI);
        Common.bump = bump;

        const audio = new P3.AudioManager();
        Common.audio = P3.Button.audio = audio;

        const assets = new P3.AssetManager();
        assets.signals.audioFile.add(audio.addSound, audio);
        Common.assets = assets;

        Common.language = language;
        Common.tabActive = true;

        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
        //PIXI.settings.MIPMAP_TEXTURES = false;

        TweenMax.defaultOverwrite = "none";
        TweenLite.lagSmoothing();

        const options = {
            width: this._width,
            height: this._height,
            holderId: "game",
            portrait: false,
            rotateImageUrl: "assets/images/rotate.jpg",
            rotateImageColor: "#000000",
            aspectRatioFillHeight: true
        };

        const view = new P3.View(options);
        view.signals.ready.addOnce(function (canvas) {
            const options = {};
            options.view = canvas;
            options.transparent = false;
            options.antialias = true;
            options.preserveDrawingBuffer = false;
            options.resolution = 1;

            const stage = new PIXI.Container();
            Common.stage = stage;

            const input = new P3.Input();
            input.init(stage, canvas);
            Common.input = input;

            /*
             //on clicking the document focus on canvas, fix for buttons not working on mobile
             document.onclick = () => {
             canvas.focus();
             };
             */

            if (P3.utils.isCocoonJS()) {
                stage.scale.x = window.innerHeight / this._height;
                stage.scale.y = window.innerHeight / this._height;
                console.log(stage.scale.x, stage.scale.y, window.innerWidth, window.innerHeight);
            }

            const renderer = new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
            //const renderer = !P3.utils.isCocoonJS() ?
            //   PIXI.autoDetectRenderer(this._width, this._height, options) :
            //  new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
            renderer.backgroundColor = 0xf7f7f7;
            Common.renderer = renderer;
            Common.isWebGL = (renderer instanceof PIXI.WebGLRenderer);

            const scene = new P3.SceneManager(renderer);
            Common.scene = scene;
            Common.stage.addChild(scene.view);

            let ticker = new P3.Ticker();
            ticker.init(()=> {
                scene.update();
                input.update();
                window.deltaTime = P3.Ticker.dt;
            }, ()=> {
                renderer.render(Common.stage);
            });

            window.delay = function (callback, delay, scope) {
                return TweenMax.delayedCall(delay, callback, [], scope);
            };
            window.delayarg = function (callback, delay, args, scope) {
                return TweenMax.delayedCall(delay, callback, args, scope);
            };
            window.translate = function (str) {
                let s = Common.config.strings[str];
                s = s && s[Common.language];
                return (typeof s !== "undefined") ? s : str;
            };

            this.loadPreloader();
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        view.init();
        Common.view = view;
    }

    loadPreloader() {
        const files = [
            // {name: "preloader", url: "images/" + "preloader" + ".json"}
        ];

        if (files.length) {
            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.complete.addOnce(function () {
                Main.createConfig();
                this.loadAssets();
            }, this);
            Common.assets.load();
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {
        const ext = P3.AssetManager.AUDIO_FILE_EXTENSION;

        const files = [
            {name: "dirt_strip", url: "images/" + "dirt_strip" + ".png"},
            {name: "dirt_top", url: "images/" + "dirt_top" + ".png"},
            {name: "knight", url: "images/" + "knight" + ".png"},
            {name: "cube", url: "images/" + "cube" + ".png"},
            {name: "chr_sliced", url: "images/" + "chr_sliced" + ".png"},
            {name: "tank", url: "images/" + "tank" + ".png"},
            {name: "house", url: "images/" + "obj_house1" + ".png"},
            {name: "tree", url: "images/" + "tree3" + ".png"},

            {name: "grass", url: "images/" + "grass" + ".jpg"},
            //--bg--//
            //   {name: "bg", url: "images/" + "bg_environment_01_1x" + ".png"},
            //  {name: "char_mask", url: "images/" + "char_mask" + ".png"},
            //--sheets--//
            //  {name: "dna_elements_1x", url: "images/" + "dna_elements_1x" + ".json"},
            //  {name: "dna_char_rapunzel_1x", url: "images/" + "dna_char_rapunzel_1x" + ".json"},
            //{name: "ui_buttons_1x", url: "images/" + "ui_buttons_1x" + ".json"},
            //--spine--//
            //  {name: "mickey_dna_seq_01", url: "images/" + "mickey_dna_seq_01" + ".json"},
            //--data--//
            {name: "config", url: "data/" + "config" + ".json"}
            //--sounds--//
            //     {name: "sfx_btn_down_01", url: "audio/" + "sfx_btn_down_01" + ext},
            //    {name: "sfx_btn_over_01", url: "audio/" + "sfx_btn_over_01" + ext}
        ];

        for (let i = 1; i <= 12; i++) {
            let obj = {name: "iso_" + i, url: "images/" + "iso_" + i + ".png"};
            files.push(obj);
        }

        if (files.length) {

            //--fix for text not being loaded, create some text then wait a little before starting preloader--..
            const txt = new PIXI.Text("", {size: 1, fontFamily: "Noto Sans"});
            Common.stage.addChild(txt);

            delay(()=> {
                Common.stage.removeChild(txt);
                txt.destroy();

                this._preloader = new PreloaderScene();
                Common.scene.add(this._preloader);

                Common.assets.addFiles(files, "assets/");
                Common.assets.signals.progress.add(this.onLoadingProgress, this);
                Common.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
                Common.assets.load();
            }, 0.2);

        } else {
            this.startGame();
        }
    }

    static createConfig() {
        Common.config = {};
    }

    /**
     * @param [t=0]
     */
    startGame(t = 0) {
        delay(function () {
            this._game = new Application();
            this._game.init();
        }, t, this);
    }

    /**
     * @param {Event} event
     */
    onLoadingProgress(event) {
        this._preloader.loaded = event.progress / 100.0;
    }

    onLoadingCompleted() {
        Common.assets.signals.progress.removeAll();
        Common.assets.signals.complete.removeAll();

        this._preloader.loaded = 1;

        this._preloader.onLoadComplete();

        this._preloader.signals.next.add(()=> this.startGame(0));
        //  if (isMobile.any) {
        // this._preloader.signals.next.add(function () {
        //       this.startGame(0);
        //   }, this);
        //   } else {
        //      this.startGame(1);
        //   }
    }

    /**
     * @param {boolean} correct
     */
    onCanvasResize(correct) {
        if (correct) {
            Common.renderer.resize(P3.View.width, P3.View.height);
            if (Common.scene) {
                Common.scene.resize();
            }
        }
    }
}

function createText(copy, config) {
    config = config || {};
    const cfg = config;
    let textView;
    if (Common.language === "ar") {

    } else {

        cfg.fontFamily = "Noto Sans";

        cfg.fontSize = config.size || config.fontSize || 45;
        cfg.fill = config.fill || 0x565656;
        cfg.align = config.align || "left";
        cfg.letterSpacing = config.letterSpacing || 0;
        if (config.stroke) {
            cfg.stroke = config.stroke;
            cfg.strokeThickness = config.strokeThickness || 8;
        }
        if (config.wordWrap || cfg.wordWrapWidth) {
            cfg.wordWrap = true;
            cfg.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.dropShadow || cfg.dropShadowDistance) {
            cfg.dropShadow = true;
            cfg.dropShadowDistance = config.dropShadowDistance || 8;
        }

        textView = new PIXI.Text(copy, cfg);
    }
    return textView;
}
window.createText = createText;

function sliceButton(copy, icon, cb, ctx) {
    //--some slightly hacky stuff to get nine slice buttons to work nicely--//

    const a = Common.assets;

    const textView = createText(copy, {size: 14, fill: 0xffffff, fontWeight: "bold"});
    textView.anchor.set(0.5);

    const height = 50;//per pandora guidelines, all buttons 50px high
    const width = textView.width + 80;//per pandora guidelines, 40px each side of text at all times

    const btnBack = new PIXI.mesh.NineSlicePlane(a.texture("pandora_9slice_button_red_standard"), 15, 15, 15, 15);
    btnBack.width = width;
    btnBack.height = height;

    const btnOver = new PIXI.mesh.NineSlicePlane(a.texture("pandora_9slice_button_red_rollover"), 15, 15, 15, 15);
    btnOver.width = width;
    btnOver.height = height;

    const offTexture = Common.renderer.generateTexture(btnBack);
    const overTexture = Common.renderer.generateTexture(btnOver);
    Common.generatedButtonTextures.push(overTexture, offTexture);//push them so we can destroy textures between scenes

    const states = new P3.ButtonStates();
    states.normal = offTexture;
    states.over = overTexture;

    if (icon) states.icon = a.texture("icon_" + icon);
    const btn = new P3.Button(states);

    btnBack.destroy();
    btnOver.destroy();

    btn.overSoundName = "sfx_btn_over_01";
    btn.clickSoundName = "sfx_btn_down_01";
    btn.signals.click.add(cb, ctx);

    /*
     //--more weird crap to handle changing font tint etc--//
     let overArea = P3.utils.sprite(PIXI.Texture.EMPTY, btn, new PIXI.Point(0.5, 0.5));
     overArea.width = btn.width;
     overArea.height = btn.height;
     overArea.interactive = true;

     overArea.mouseover = (e)=> {
     if (btn.textView) {
     // btn.textView.tint = 0xffffff;
     }
     if (btn.altIcon) {
     btn._icon.texture = a.texture(btn.overTextureName);
     }
     };
     overArea.mouseout = (e)=> {
     if (btn.textView) {
     // btn.textView.tint = 0x6a55a4;
     }
     if (btn.altIcon) {
     btn._icon.texture = a.texture(btn.upTextureName);
     }
     };
     */

    btn.textView = textView;
    btn.addChild(textView);

    return btn;
}
window.sliceButton = sliceButton;
